<template>
  <div data-testid="subscription-blocked-page" class="subscription-blocked-page">
    <page-header
      :title="t('Acesso bloqueado')"
      icon="pi pi-lock"
    />

    <box>
      <p v-if="status">
        {{ t('Situação da assinatura') }}: <strong>{{ status }}</strong>
      </p>
      <p v-else>
        {{ t('Sua franquia não tem assinatura ativa. Assine um plano para retomar o acesso.') }}
      </p>

      <!-- OWNER variant (Full / Franqueado): subscribe CTA -->
      <Button
        v-if="isOwner"
        data-testid="subscription-pay-cta"
        :label="t('Assinar plano')"
        icon="pi pi-credit-card"
        :disabled="currentFranquiaId == null"
        @click="openSubscribeModal"
      />

      <!-- EMPLOYEE variant (Gerente / Operador / Atendente): read-only; notify stub -->
      <notify-owner-stub v-else />
    </box>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSubscriptionStatus } from '../../composables/useSubscriptionStatus'
import { eventBus } from '../../eventBus'
import permissionsService from '../../services/permissionsService'
import PageHeader from '../../ui/PageHeader.vue'
import NotifyOwnerStub from './NotifyOwnerStub.vue'

const { t } = useI18n()
const { status, currentFranquiaId } = useSubscriptionStatus()

/** True for Full or Franqueado — these users may subscribe. */
const isOwner = computed<boolean>(() =>
  permissionsService.isUserInGroups(['Full', 'Franqueado']),
)

function openSubscribeModal(): void {
  if (currentFranquiaId.value == null) return
  eventBus.emit('modal.subscribe.open', { franquia_id: currentFranquiaId.value })
}
</script>
